/**
 * @file sprint.tsx
 * @description Компонент страницы каталога спринтов для управления сущностями спринтов в системе управления 
 * задачами. Предоставляет функциональность создания, редактирования и просмотра спринтов с отслеживанием по 
 * времени. Включает табличное представление, отображающее названия спринтов, даты начала и окончания для 
 * планирования проектов и управления временными рамками. Поддерживает форматирование дат/времени и является 
 * важным элементом для гибких методологий управления проектами.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies ['@forms/sprint', '@utils/table-view']
 * @related-files ['@forms/sprint/index.tsx']
 */

import { SprintForm } from '@forms/sprint';
import { getDateTimeCell, getDefaultCell } from '@utils/table-view';

export const title = 'Спринты';
export const searchModalTitle = 'Выбор спринта';
export const type = 'Sprint';
export const path = 'sprint';
export const form = SprintForm;

export const columns = [
    {
        id: '$item',
        header: [{ text: 'Наименование' }],
        width: 175,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'dateStart',
        header: [{ text: 'Дата начала' }],
        render: (cellValue: number) => getDateTimeCell(cellValue)
    },
    {
        id: 'dateEnd',
        header: [{ text: 'Дата окончания' }],
        render: (cellValue: number) => getDateTimeCell(cellValue)
    }
];
